module.exports = __webpack_public_path__ + "static/img/ri-logout-box-r-line.9bddc32a.svg";